module.exports = __webpack_public_path__ + "static/media/maskShapesNew.21c7355f.svg";